import { useMutation } from "react-query";
import {
  postVisitConsentConfirm,
  VisitConsentConfirmPayload,
  VisitConsentConfirmResponse
} from "./visit-consent-confirm.api";
import { RemoteApiError } from "../useRemote/types";
import { withMutateAsyncSafe } from "../useRemote/useRemoteMutation";

export function useRemoteConfirmConsent() {
  const mutation = useMutation<
    VisitConsentConfirmResponse,
    RemoteApiError,
    VisitConsentConfirmPayload
  >(["visitor-consent", "confirm"], async payload => {
    const { data } = await postVisitConsentConfirm(payload);
    return data;
  });

  return withMutateAsyncSafe(mutation);
}
